<template>
  <div class="Kp_list">
    <div class="Kp_center">
      <!--轮播-->
      <div class="home_swiper">
        <!--轮播//插件-->
        <div id="bigOne_swiper" class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in swiperData" :key="item.articleId">
              <img :src="item.url" alt="">
            </div>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" style="color: #fff;"></div><!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next" style="color: #fff;"></div><!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        </div>
      </div>
      <!--选择-->
      <div v-if="0" class="diseaseList_select">
        <div class="diseaseList_selectCentre">
          <!--科室-->
          <div class="oneDepartment">
            <div class="title">科室</div>
            <div class="oneDepartment_list">
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">妇产科</div>
              <div class="item_list">儿科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">不孕不育科</div>
              <div class="item_list">其他</div>
            </div>
          </div>
          <!--疾病-->
          <div class="twoDepartment" >
            <div class="title">疾病</div>
            <div ref="listShow" :class="showList?'active':''" class="twoDepartment_list" >
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">妇产科</div>
              <div class="item_list">儿科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">不孕不育科</div>
              <div class="item_list">其他</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">妇产科</div>
              <div class="item_list">儿科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">不孕不育科</div>
              <div class="item_list">其他</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">妇产科</div>
              <div class="item_list">儿科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">儿科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">不孕不育科</div>
              <div class="item_list">其他</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">其他</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <div class="item_list">其他</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">内科</div>
              <div class="item_list">外科</div>
              <div class="item_list">男性科</div>
              <div class="item_list">无官科</div>
              <div class="item_list">皮肤性病科</div>
              <div class="item_list">肿瘤科</div>
              <span class="abs_box" v-if="flagList" @click="showList = !showList">{{showList?'展示':'收起'}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="center_list">
        <!--card区-->
        <div class="voice_list">
          <div @click="handleTGoShow(item.id)" class="item" v-for="item in audioData" :key="item.id">
            <div class="item_top">
              <img :src="item.headImage" alt="">
              <div class="item_top_center">
                <div>{{item.doctorName}}</div>
                <span>{{item.doctorLevelName}}</span>
              </div>
            </div>
            <div class="item_bottom">
              <div class="voice_title">{{item.title}}</div>
              <div class="audio_box">
                <Audio :styles="{width:'189px', height:'35px'}" :url="item.url"/>
              </div>
            </div>
          </div>
        </div>
        <!--分页-->
        <div class="Pagination">
          <Pagination  :pageSize="total" v-model="dataForm.page" @on-jump="jump" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '../../components/pagination/index'
  import Audio from '../../components/audio/Index'
  import Swiper from 'swiper'
  export default {
    name: "List",
    components:{
      Pagination,
      Audio,
    },
    data(){
      return {
        showList:false, // 展示收起
        flagList:true, // 按钮显示
        total:10,  // 总分页数
        dataForm:{
          page:1,
          size:15,
        },
        swiperData:[],
        audioData:[],
      }
    },
    methods:{
      _listShow(){
        this.$nextTick(()=> {
          let height = this.$refs.listShow.offsetHeight
          console.log(height);
          if(height>102){
            this.flagList = true
            this.showList = true
          }
          if(height<=102){
            this.flagList = false
            this.showList = false
          }
        })
      },
      jump(page){
        this.dataForm.page = page
        this.getAudioList()
      },
      handleTGoShow(id) {
        this.$router.push({path:'/kpVoice/kpVoiceShow/'+id,query:{}})
      },
      getAudio(){
        let audios = document.getElementsByTagName("Audio");
        // 暂停函数
        function pauseAll() {
          var self = this;
          [].forEach.call(audios, function (i) {
            // 将audios中其他的audio全部暂停
            i !== self && i.pause();
          })
        }
        // 给play事件绑定暂停函数
        [].forEach.call(audios, function (i) {
          i.addEventListener("play", pauseAll.bind(i));
        })
      },
      // 初始化头部轮播
      _initSwiper() {
        let mySwiper = new Swiper('#bigOne_swiper', {
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          loop : true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          //用户操作后, autoplay会默认停止, 这个是取消禁止autoplay
          autoplayDisableOnInteraction: false,
        })
      },
      // 获取轮播数据
      getSwiperDara() {
        let params = {
          type:2
        }
        this.$api.mykp_home.findSwiperTree(params) .then(res => {
          if(res.code == '000000') {
            this.swiperData = res.infos
            this.$nextTick(() => {
              this._initSwiper()
            })
          }
        })
      },
      // 获取语音列表
      getAudioList() {
        const data = {
          type:2,
          page:this.dataForm.page,
          size:this.dataForm.size,
          hot:false
        }
        this.$api.mykp_home.findVideoTree(data) .then(res => {
          if(res.code == '000000'){
            this.audioData = res.infos.list
            this.total = Math.ceil(res.infos.total/15)
            this.$nextTick(()=>{
              this.getAudio()
            })
          }
        })
      },
    },
    mounted() {
      // this._listShow()
      this.getAudio()
      this.getSwiperDara()
      this.getAudioList()
    },
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .Kp_list{
    .Kp_center{
      width: 1200px
      margin 0 auto
      .diseaseList_select{
        margin-top 20px
        .diseaseList_selectCentre{
          border 1px solid #eee
          border-radius: 9px;
          padding 20px 50px 10px 20px
          position relative
          .oneDepartment{
            display flex
            flex-wrap wrap
            align-items center
            min-height 60px
            &:after{
              content ''
              display block
              height: 1px
              width 100%
              border-top 1px dashed #eee
              margin 10px  10px 0 10px
            }
            .title{
              font-weight: 700;
              font-style: normal;
              font-size: 16px;
              color: #333
              margin-right 20px
            }
            .oneDepartment_list{
              flex 1
              display flex
              flex-wrap wrap
              .item_list{
                font-size: 14px;
                color: #333
                margin-right 20px
                padding 10px 0
                cursor: pointer
              }
            }
          }
          .twoDepartment{
            display flex
            flex-wrap wrap
            align-items center
            min-height 60px
            .title{
              font-weight: 700;
              font-style: normal;
              font-size: 16px;
              color: #333
              margin-right 20px
            }
            .twoDepartment_list{
              flex 1
              display flex
              flex-wrap wrap
              height: auto
              .item_list{
                font-size: 14px;
                color: #333
                margin-right 20px
                padding 10px 0
                cursor: pointer
              }
              &.active{
                overflow hidden
                height: 102px
              }
              .abs_box{
                position absolute
                right:7px
                bottom:7px
                font-size 14px
                color: #fff
                width: 65px;
                height: 30px;
                background #1083f8
                text-align: center
                line-height 30px
                border-radius 5px
                cursor: pointer
              }
            }
          }
        }
      }
      .center_list{
        margin-top 40px
        .voice_list{
          display flex
          flex-wrap wrap
          .item{
            margin-right 17px
            width: 224px;
            height: 284px;
            border 1px solid #8cd4a7
            border-radius: 7px;
            padding 10px 0
            margin-bottom 30px
            cursor: pointer
            &:nth-child(5n){
              margin-right 0
            }
            .item_top{
              display flex
              flex-direction column
              align-items center
              &:after{
                content ''
                display block
                width: 100%
                height: 1px
                border-top 1px dashed #eee
                margin-top 15px
              }
              >img{
                width: 135px;
                height: 135px;
                border-radius 50%
              }
              .item_top_center{
                width: 80%
                display flex
                justify-content space-around
                align-items center
                margin-top 10px
                >div{
                  max-width 60px
                  font-weight: 700;
                  font-style: normal;
                  font-size: 18px;
                  color: #000000;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                >span{
                  display block
                  max-width 70px
                  font-size: 14px;
                  color: #000000;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .item_bottom{
              display flex
              flex-direction column
              align-items center
              .voice_title{
                max-width 200px
                margin-top 10px
                font-size: 16px;
                color: #333
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .audio_box{
                margin-top 10px
                >audio{
                  width: 200px;
                  height: 35px;
                  outline none
                }
              }
            }
          }
        }
      }
    }
  }

  .Pagination{
    margin-top 20px
  }
  // 轮播区
  .home_swiper{
    width 1200px
    margin 0 auto
    // 轮播
    .swiper-container {
      margin-top 20px
      width:100%
      height 600px
      .swiper-slide{
        cursor: pointer
      }
      img{
        width 100%
        height 100%
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/kpVoice/List.vue